import React, { useState } from 'react';
import Logo from './Logo';

const NAV_ITEMS = [
  { href: '/#products', label: 'Products' },
  { href: '/#services', label: 'Services' },
  { href: '/#company', label: 'Company' },
  { href: '/contact', label: 'Contact' },
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isHome = window.location.pathname === '/';

  return (
    <header className={`${isHome ? 'absolute bg-transparent' : 'sticky border-b border-ink/10 bg-[#fffaf2]/95 backdrop-blur-md'} left-0 right-0 top-0 z-50 text-ink`}>
      <nav className="mx-auto flex h-24 max-w-[90rem] items-center gap-6 px-6 md:px-12 lg:px-16" aria-label="Main navigation">
        <a href="/" className="mr-auto inline-flex shrink-0 items-center" aria-label="Lokyis Ltd home">
          <Logo heightClass="h-8 md:h-9" />
        </a>

        <ul className="hidden items-center gap-9 lg:flex">
          {NAV_ITEMS.map(({ href, label }) => <li key={href}><a href={href} className="nav-link">{label}</a></li>)}
        </ul>
        <a href="/contact" className="btn-navy hidden min-h-11 px-5 py-2.5 lg:inline-flex">Get in touch <span aria-hidden="true">→</span></a>

        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="inline-flex min-h-11 items-center justify-center px-2 text-sm font-semibold lg:hidden"
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          aria-controls="mobile-navigation"
        >
          {isOpen ? 'Close' : 'Menu'}
        </button>
      </nav>

      <div id="mobile-navigation" className="mobile-menu-panel mx-4 bg-[#fffaf2] shadow-xl lg:hidden" data-open={isOpen}>
        <ul className="flex flex-col gap-1 p-4">
          {NAV_ITEMS.map(({ href, label }) => (
            <li key={href}><a href={href} onClick={() => setIsOpen(false)} className="block px-3 py-3 text-sm font-semibold">{label}</a></li>
          ))}
        </ul>
      </div>
    </header>
  );
};

export default Header;
